import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { DatePipe } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';

import { DfService } from '../../../../core/df/df.service';
import { InvoiceOps } from '../../../../core/df/df.types';
import { StatusChipComponent } from '../../../../shared/status-chip/status-chip';
import { IconComponent } from '../../../../shared/icon/icon';
import { ZarPipe } from '../../../../shared/pipes/zar.pipe';

@Component({
  selector: 'app-df-invoice-queue',
  imports: [
    MatCardModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    RouterLink,
    DatePipe,
    StatusChipComponent,
    IconComponent,
    ZarPipe,
  ],
  templateUrl: './df-invoice-queue.html',
  styleUrl: './df-invoice-queue.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DfInvoiceQueueComponent implements OnInit {
  private readonly dfService = inject(DfService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly destroyRef = inject(DestroyRef);

  @ViewChild(MatPaginator) set paginator(p: MatPaginator) {
    if (p) this.dataSource.paginator = p;
  }

  protected readonly dataSource = new MatTableDataSource<InvoiceOps>([]);
  protected readonly isLoading = signal(true);
  protected readonly loadError = signal(false);

  protected get invoiceCount(): number {
    return this.dataSource.data.length;
  }

  protected readonly pageSizeOptions = [25, 50, 100];

  protected readonly columns = [
    'debtor',
    'invoice_number',
    'amount',
    'invoice_status',
    'submitted',
  ];

  ngOnInit(): void {
    this.load();
  }

  protected load(): void {
    this.isLoading.set(true);
    this.loadError.set(false);
    this.dfService
      .opsListInvoices()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res) => {
          this.dataSource.data = res.invoices;
          this.isLoading.set(false);
          this.cdr.markForCheck();
        },
        error: () => {
          this.isLoading.set(false);
          this.loadError.set(true);
          this.cdr.markForCheck();
        },
      });
  }
}
